import wx from 'weixin-js-sdk'
import {WEIXIN_BASE} from './base'

var WEIXIN_CHAT = {
    /**
     * 从手机相册选择图片or拍照
     * 微信授权完再调取
     */
    chooseImage(cb) {
        
        WEIXIN_BASE.getAuthorationAndConfigJsSDK(function(){
            wx.chooseImage({
                count: 9, // 默认9
                sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success: function (res) {
                    var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    // 有图片id 上传图片到服务器
                    console.log('chooseImage---successs-----', localIds)
                    // 获取前端展示图片的base64编码
                    var index = 0;
                    function addFunc() {
                        if(index >= localIds.length) {
                            return;
                        }
                        wx.getLocalImgData({
                            localId: localIds[index], // 图片的localID
                            success: function (res) {
                                var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                                console.log('getLocalImgData---successs-----', index)
                                if(cb && typeof(cb) == 'function') {
                                    cb(localIds[index], localData);
                                }
                                index++;
                                addFunc();
                            }
                        });
                    }
                    addFunc();

                    // 执行前端回调
                    // idsPromise.then(() => {
                    //     if(cb && typeof(cb) == 'function') {
                    //         cb(localDataArray, localIds)
                    //     }
                    // });
                }
            });  
        });
    }


}

export {
    WEIXIN_CHAT
}